(() => {
  const fields = ['title', 'tag', 'product_type', 'variants.title', 'variants.sku', 'variants.barcode'];
  const builders = ['Custom UV DTF Gang Sheets with Auto Builder', 'Custom UV DTF Gang Sheets with Manual Builder'];
  function normalize(value) {
    return String(value || '').replace(/&(?:amp;)*(?:quot|#34|#x22);/gi, '"');
  }
  function compile(value) {
    const text = normalize(value).trim().replace(/\s+/g, ' ');
    if (!text || text.length > 160 || /[:()\\*]|\b(?:AND|OR|NOT)\b/.test(text)) return text;
    const terms = text.match(/"[^"]+"|[^\s"]+/g) || [];
    if (terms.length > 12) return text;
    return terms.map(term => {
      term = term.replace(/^"|"$/g, '');
      if (/^personali[sz]ed$/i.test(term)) term = 'personalized';
      const clauses = fields.map(field => `${field}:"${term}"`);
      if (term.toLowerCase() === 'personalized') builders.forEach(title => clauses.push(`title:"${title}"`));
      return `(${clauses.join(' OR ')})`;
    }).join(' AND ');
  }
  function readable(value) {
    const text = normalize(value);
    if (!text.startsWith('(title:"') || !text.includes(' OR variants.barcode:"')) return text;
    return text.split(') AND (').map(part => part.match(/title:"([^"]*)"/)?.[1] || '').join(' ');
  }
  window.MKSearchPrecision = { compile, readable };
  document.addEventListener('formdata', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !/\/search\/?$/.test(action.pathname)) return;
    const input = form.querySelector('input[type="search"][name="q"]');
    if (input) {
      const query = compile(input.value);
      event.formData.set('q', query);
      if (query !== input.value.trim()) event.formData.set('type', 'product');
    }
  }, true);
  function normalizePage() {
    const url = new URL(location.href);
    if (!/\/search\/?$/.test(url.pathname) || !url.searchParams.has('q') || window.Shopify?.designMode) return;
    const raw = url.searchParams.get('q');
    const compiled = compile(raw);
    if (compiled === raw) return;
    url.searchParams.set('q', compiled);
    url.searchParams.set('type', 'product');
    url.searchParams.delete('page');
    location.replace(url.href);
  }
  normalizePage();
})();
